import { render, staticRenderFns } from "./PreferenceList.vue?vue&type=template&id=d6e6284e&scoped=true&"
import script from "./PreferenceList.vue?vue&type=script&lang=js&"
export * from "./PreferenceList.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceList.vue?vue&type=style&index=0&id=d6e6284e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e6284e",
  null
  
)

export default component.exports